import React, { useEffect, useState } from 'react';
import {useStore} from "zustand/index";
import { Descriptions, DescriptionsProps } from 'antd';
import {useMediaQuery} from "react-responsive";
import cashTxAPI from '../../../api/cashTxAPI';
import { Cash } from '../../../types/Cash';
import { formatCurrency } from '../../../util/format';
import {useMessageStore} from "../../../stores/messageStore";

const emptyCashData = {
  id: '',
  userId: '',
  cash: 0,
  pendingOutTotal: 0,
  availableCash: 0,
};

type CashDescriptionProps = {
  userId: string;
  style?: React.CSSProperties; // 스타일을 props로 추가
  onSelect?: (cash: Cash) => any;
};

const CashDescription: React.FC<CashDescriptionProps> = ({ userId, style, onSelect }) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })

  const { setMessages } = useStore(useMessageStore);
  const [cash, setCash] = useState<Cash>(emptyCashData);

  useEffect(() => {
    if (userId) {
      cashTxAPI.fetchCashAPI(userId)
        .then((cashData) => {
          if (!cashData) {
            setMessages('error', 'cashData가 없습니다.');
          }
          setCash(cashData || emptyCashData);
          onSelect && onSelect(cashData || emptyCashData);
        })
        .catch((error) => {
          console.error("Error fetching user cash:", error);
        });
    }
  }, [userId]);

  const items: DescriptionsProps['items'] = [
    {
      label: <div style={{
        textAlign: 'center',
        width: '100%'
      }}>총액</div>,
      children: <div style={{ textAlign: 'center' }}>{formatCurrency(Number(cash.cash), 'KRW')}</div>,
    },
    {
      label: <div style={{ textAlign: 'center', width: '100%' }}>지급대기중</div>,
      labelStyle: { textAlign: 'center' },
      children: <div style={{ textAlign: 'center' }}>{formatCurrency(Number(cash.pendingOutTotal), 'KRW')}</div>
    },
    {
      label: <div style={{ textAlign: 'center', width: '100%' }}><b>사용가능</b></div>,
      labelStyle: { textAlign: 'center' },
      children: <div style={{ textAlign: 'center' }}><b>{formatCurrency(Number(cash.availableCash), 'KRW')}</b></div>
    },
  ];

  return (
    <Descriptions
      bordered
      column={(isTabletOrMobile && isPortrait) ? 1 : 3}
      layout="vertical"
      size="small"
      items={items}
      style={style}
    />
  );
};

export default CashDescription;
